import instance from "../axios/axios";

// Fetch all appointments with pagination and search
export const getAppointments = async ({ page, limit, search,status }) => {
    try {
        const response = await instance.get(`/api/appointment/appointments?page=${page}&limit=${limit}&search=${search}&status=${status}`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error; 
    }
};

// Fetch a single appointment by ID
export const getAppointmentById = async (id) => {
    try {
        const response = await instance.get(`/api/appointment/appointments/${id}`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error; 
    }
};

// Create a new appointment
export const createAppointment = async (appointmentData) => {
    try {
        const response = await instance.post(`/api/appointment/appointments`, appointmentData);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error; 
    }
};

// Update an existing appointment
export const updateAppointment = async (id, appointmentData) => {
    try {
        const response = await instance.put(`/api/appointment/appointments/${id}`, appointmentData);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error; 
    }
};

// Delete an appointment
export const deleteAppointment = async (id) => {
    try {
        const response = await instance.delete(`/api/appointment/appointments/${id}`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error; 
    }
};


export const uploadLabResultToCloudinary = async (file) => {
    try {
        const formData = new FormData();
        formData.append("file", file);
        const response = await instance.post("/api/cloudinary/upload/lab", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const uploadReferralFormToCloudinary = async (file) => {
    try {
        const formData = new FormData();
        formData.append("file", file);
        const response = await instance.post("/api/cloudinary/upload/referral", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}



export const deleteFileFromCloudinary = async (publicId) => {
    try {
        const response = await instance.post("/api/cloudinary/delete", {
            data: { publicId },
        });

        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}